export const LOGIN_ERRORS = {
  WRONG_CREDENTIALS: "Votre adresse email et/ou mot de passe sont incorrects.",
  SERVER_ERROR:
    "Nous sommes navrés. La connexion n'a pas pu avoir lieu. Veuillez ré-essayer ou nous contacter si le problème persiste."
};
